import React, { useCallback, useRef, useState } from 'react';
import moment from 'moment';
import Filter from '@/pages/dashboard/components/NewFilter';
import { timeRange } from '@/pages/dashboard/pages/engagement/_config';
import { setBtnPointLog } from "@/pages/dashboard/utils/utils";
import { useSelector } from 'umi';
import { commonDateDefault } from '../../utils/dateUtils';

// 筛选器路径
const FILTER_PATH = 'engagement/return';

const firstWordUpper = (str) => {
  if (!str) return str;
  const firstLetter = str.charAt(0);
  const firstLetterCap = firstLetter.toUpperCase();
  const remainingLetters = str.slice(1);
  return firstLetterCap + remainingLetters === 'Date' ? 'Day' : firstLetterCap + remainingLetters;
};

/**
 *
 * @param props
 * @param props:filterConfirm 筛选器确认函数
 * @param props:filterReset 筛选器重置函数
 * @param props:setFilterLoading 筛选器loading设置，透传到筛选器组件内部，获取到筛选器列表时区等数据之后，设置为false，测试才可进行页面和组件中的接口调用
 * @param props:filterInit 初始化函数，会向外部传递初始化后的筛选器值
 * @returns
 */

const ReturnFilter = (props: any) => {
  const { filterConfirm, filterReset, buttonLogConfig, setFilterLoading, filterInit, openSticky = false, path, children, isHaveFilterSave, timeZone = 0 } = props;
  const filterValueRef = useRef<any>(null); // 筛选器值，此处不用state，更新formValue同样会触发组件更新

  const { seasonInfo } = useSelector((state: any) => 
  // 初始可能为undefied,在此加兜底
    ({
      seasonInfo: state?.dashboardSetting?.gameConfig?.season_info || { date: [], week: [], month: [] },
    })
  );

  // 设置inputList
  const [inputList] = useState([commonDateDefault(timeZone, seasonInfo)]);

  const handleConfirm = (value: any) => {
    filterValueRef.current = value;
    filterConfirm?.({
      ...value,
      rangeTime: [
        value?.rangeTime?.value?.[0]?.format('YYYY-MM-DD'),
        value?.rangeTime?.value?.[1]?.format('YYYY-MM-DD')
      ],
      timeType: firstWordUpper(value?.rangeTime?.type),
      pagePath: path
    });
    // 打点，沟通后打点操作放在业务代码的confirm和reset中，不封装在新版本筛选器中
    setBtnPointLog(buttonLogConfig, value);
  };

  const handleReset = (value: any) => {
    filterValueRef.current = value;
    filterReset?.({
      ...value,
      rangeTime: [
        value?.rangeTime?.value?.[0]?.format('YYYY-MM-DD'),
        value?.rangeTime?.value?.[1]?.format('YYYY-MM-DD')
      ],
      timeType: firstWordUpper(value?.rangeTime?.type),
      pagePath: path
    });
    // 打点，沟通后打点操作放在业务代码的confirm和reset中，不封装在新版本筛选器中
    setBtnPointLog(buttonLogConfig, value, true);
  };

  const handleInit = (value: any) => {
    filterValueRef.current = value;
    filterInit?.({
      ...value,
      rangeTime: [
        value?.rangeTime?.value?.[0]?.format('YYYY-MM-DD'),
        value?.rangeTime?.value?.[1]?.format('YYYY-MM-DD')
      ],
      timeType: firstWordUpper(value?.rangeTime?.type),
      pagePath: path
    });
    setFilterLoading(false);
  };

  return (
    <Filter
      config={props.config}
      openSticky={openSticky}
      path={path || FILTER_PATH}
      value={filterValueRef.current}
      latestDateType={''}
      inputList={inputList}
      onInit={handleInit}
      onConfirm={handleConfirm}
      onReset={handleReset}
      isHaveFilterSave={isHaveFilterSave}
    >
      {children}
    </Filter>
  );
};

export default ReturnFilter;
